import { EmojiRain } from "../components/effects";
import { Stepper } from "../components/common";
import { SwipeCard } from "../components/SwipeCard";
import { useController, useGame } from "../context";

export function SwipeScreen() {
  const controller = useController();
  const deck = useGame((s) => s.deck);
  const index = useGame((s) => s.index);
  const matchId = useGame((s) => s.matchId);
  const solo = useGame((s) => s.session?.kind === "solo");
  const peerOnline = useGame((s) => s.peerOnline);

  const matched = matchId === null ? null : (deck.find((c) => c.id === matchId) ?? null);
  const current = matched ?? deck[index];
  if (!current) return null;

  return (
    <section className="screen">
      <Stepper index={matched ? deck.indexOf(matched) : index} total={deck.length} />
      {!solo && !peerOnline && <p className="hint">Второй участник не в сети</p>}
      <div className="card-container">
        <SwipeCard
          key={current.id}
          card={current}
          frozen={matched !== null}
          onVote={(kind) => controller.vote(kind)}
        />
        {matched ? (
          <div className="match">
            <EmojiRain />
            <div className="match__message">{solo ? "Ваш выбор 🎬" : "🔥 Ваш выбор совпал!"}</div>
            <button
              type="button"
              className="btn btn--green"
              onClick={() => controller.openMovie(matched)}
            >
              Искать на Кинопоиске
            </button>
            <button type="button" className="btn" onClick={() => controller.goHome()}>
              🏠 На главную
            </button>
          </div>
        ) : (
          <div className="vote-buttons">
            <button
              type="button"
              className="btn"
              aria-label="Не нравится"
              onClick={() => controller.vote("dislike")}
            >
              ❌
            </button>
            <button
              type="button"
              className="btn"
              aria-label="Нравится"
              onClick={() => controller.vote("like")}
            >
              <span className="vote-buttons__check">✓</span>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
